import React from 'react';

import { useIntl } from 'react-intl';

import { useCartLoadingImage } from 'hooks/use-cart-loading-image';

import LoadingAnimation from './loading-animation';
import { Container, LoadingText, LoadingTitle } from './styled';

const CartLoading = () => {
  const { formatMessage } = useIntl();
  const { alt, text } = useCartLoadingImage();

  return (
    <Container data-testid="cart-loading" aria-label={formatMessage({ id: 'checkForPricing' })}>
      <LoadingAnimation />
      <LoadingTitle>{alt}</LoadingTitle>
      <LoadingText>{text}</LoadingText>
    </Container>
  );
};

export default CartLoading;
